/**
 * The File group's Recent picker: the clips most recently worked on, newest first, one click to open.
 * Shared by the Analyser and Tagging so the same list resumes the same clip on either page.
 */
import { useQuery } from '@tanstack/react-query';
import { IMPORTS_LIST_LIMIT } from '@studio/contracts';
import { trpc } from '@/lib/trpc';

export function RecentModal({ currentId, onOpen, onLibrary, onClose }: {
  currentId: string | null;
  onOpen: (assetId: string) => void;
  onLibrary: () => void;
  onClose: () => void;
}) {
  const list = useQuery(trpc.assets.imports.queryOptions({ filter: 'all', limit: IMPORTS_LIST_LIMIT }));
  return (
    <>
      <button type="button" className="overlay overlay-btn" aria-label="Close" onClick={onClose} />
      <div className="modal picker-modal" role="dialog" aria-label="Recently processed clips">
        <div className="row between"><h2>Recently processed</h2></div>
        <div className="picker-list">
          {list.data?.map((a) => (
            <button key={a.id} type="button" className={`picker-row${a.id === currentId ? ' on' : ''}`}
              onClick={() => { onClose(); onOpen(a.id); }}>
              {a.posterUrl ? <img className="picker-thumb" src={a.posterUrl} alt="" /> : <span className="picker-thumb empty-poster" />}
              <span className="dd-label">{a.name}</span>
              <span className="sub dd-n">{a.keptSnippets ? `${a.keptSnippets} segments` : a.status === 'awaiting_upload' ? 'analysing…' : ''}</span>
            </button>
          ))}
        </div>
        <div className="row between">
          <button type="button" className="btn quiet" onClick={onClose}>Close</button>
          <button type="button" className="btn" onClick={() => { onClose(); onLibrary(); }}>Open the Library</button>
        </div>
      </div>
    </>
  );
}
